import { forwardRef } from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@mweb/zappos-ui/Tooltip';

import type { ProductBadgeProps } from 'components/common/ProductBadge/ProductBadge.types';
import { clippedWrapperClasses, containerClasses, contentClasses, tooltipClasses } from 'components/common/ProductBadge/ProductBadge.classes';
import { cn } from 'helpers/classnames';

export const ProductBadge = forwardRef<HTMLDivElement, ProductBadgeProps>((props: ProductBadgeProps, ref) => {
  const {
    children,
    helpText,
    background,
    fontColor = 'text-primary',
    badgeClassName,
    contentClassName,
    clippedWrapperClassName,
    ...forwardProps
  } = props;

  // Background and color can be any background/fontColor prop compatible color (hex, rgb, color name, gradiant etc)
  const customStyles = {
    background: `${background}`,
    className: badgeClassName,
    color: `${fontColor}`
  };

  const contentContainerProps = {
    className: cn(contentClasses, contentClassName),
    style: { color: customStyles.color }
  };

  return (
    <div ref={ref} className={cn(containerClasses, badgeClassName)} {...forwardProps}>
      <div className={cn(clippedWrapperClasses, clippedWrapperClassName)}>
        <div className={cn(customStyles.className)} style={{ background: customStyles.background }} data-test-id="badgeBackground" />
        {!helpText ? (
          <div className="relative">
            <div {...contentContainerProps}>
              <span>{children}</span>
            </div>
          </div>
        ) : (
          <div className="relative z-10">
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger>
                  <div {...contentContainerProps}>
                    <span>{children}</span>
                  </div>
                </TooltipTrigger>
                <TooltipPortal>
                  <TooltipContent side="bottom" sideOffset={4} align="start" alignOffset={16} className={tooltipClasses}>
                    {helpText}
                  </TooltipContent>
                </TooltipPortal>
              </Tooltip>
            </TooltipProvider>
          </div>
        )}
      </div>
    </div>
  );
});
